import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext'
import { useEffect, useState } from 'react'
import Checkbox from '../../../form/checkbox/Checkbox'
import CollapsibleForms from '../../../form/collapsible-forms/CollapsibleForms'
import classes from './RadioTechnologyDialog.module.scss'

const RadioTechnologyDialog = ({ data, onApply, visible, ...otherProps }) => {
  const [selectedRadioTechnology, setSelectedRadioTechnology] = useState()
  const [selectedRadioTechnologyTypes, setSelectedRadioTechnologyTypes] = useState([])
  const [otherRadioTechnology, setOtherRadioTechnology] = useState('')
  const [otherRadioTechnologyType, setOtherRadioTechnologyType] = useState('')
  const [shownRadioTechnologyFormIndices, setShownRadioTechnologyFormIndices] = useState([])

  const radioTechnologies = [
    {
      radioTechnology: '802.11',
      helpText: 'Bands (select all that apply)',
      selectionType: 'multiple',
      types: [
        {
          type: 'a',
        },
        {
          type: 'b',
        },
        {
          type: 'g',
        },
        {
          type: 'n (Wi-Fi 4)',
        },
        {
          type: 'ac (Wi-Fi 5)',
        },
        {
          type: 'ax (Wi-Fi 6)',
        },
        {
          type: 'Other',
        },
      ],
    },
    {
      radioTechnology: 'BLE (Bluetooth Low Energy)',
      helpText: 'Version (single select)',
      selectionType: 'single',
      types: [
        {
          type: 'V4.0',
        },
        {
          type: 'V4.1',
        },
        {
          type: 'V4.2',
        },
        {
          type: 'V5.0',
        },
        {
          type: 'V5.2',
        },
        {
          type: 'Other',
        },
      ],
    },
    {
      radioTechnology: 'BT (Bluetooth)',
      helpText: 'Version (single select)',
      selectionType: 'single',
      types: [
        {
          type: 'V4.0',
        },
        {
          type: 'V4.1',
        },
        {
          type: 'V4.2',
        },
        {
          type: 'V5.0',
        },
        {
          type: 'V5.2',
        },
        {
          type: 'Other',
        },
      ],
    },
    {
      radioTechnology: 'Cellular',
      helpText: 'Bands (select all that apply)',
      selectionType: 'multiple',
      types: [
        {
          type: '2G',
        },
        {
          type: '3G',
        },
        {
          type: '4G',
        },
        {
          type: '5G',
        },
        {
          type: 'LTE',
        },
        {
          type: 'Millimeter-wave (mmW)',
        },
        {
          type: 'Other',
        },
      ],
    },
    {
      radioTechnology: 'NFC',
      helpText: 'Version (single select)',
      selectionType: 'single',
      types: [
        {
          type: 'Active',
        },
        {
          type: 'Passive',
        },
      ],
    },
    {
      radioTechnology: 'RFID',
      helpText: 'Version (single select)',
      selectionType: 'single',
      types: [
        {
          type: '13.56 MHz',
        },
        {
          type: '800 MHz',
        },
        {
          type: '900 MHz',
        },
        {
          type: '125 KHz',
        },
      ],
    },
    {
      radioTechnology: 'SRD (Short Range Device)/Mifare (13.56 MHz)',
    },
    {
      radioTechnology: 'WPT (Wireless Power Transfer)',
      helpText: 'Bands (single select)',
      selectionType: 'single',
      types: [
        {
          type: '110-140 KHz',
        },
        {
          type: '2.4 GHz',
        },
        {
          type: '900 MHz',
        },
        {
          type: 'Other',
        },
      ],
    },
    {
      radioTechnology: 'Zigbee 802.15.4',
    },
    {
      radioTechnology: 'Other',
    },
  ]

  useEffect(() => {
    if (data?.radioTechnology) {
      expandRadioTechnologyTypesAccordion(data.radioTechnology, true)
    } else {
      setShownRadioTechnologyFormIndices([0])
    }
  }, [visible])

  useEffect(() => {
    setSelectedRadioTechnology(data?.radioTechnology)
    setSelectedRadioTechnologyTypes(data?.radioTechnologyTypes)
    setOtherRadioTechnology(data?.otherRadioTechnology)
    setOtherRadioTechnologyType(data?.otherRadioTechnologyType)
  }, [data])

  const expandRadioTechnologyTypesAccordion = (radioTechnology, collapseOthers) => {
    // Auto expand radio tecnology accordion.
    const selectedRadioTechnologiesOption = radioTechnologies.find(
      r => r.radioTechnology === radioTechnology
    )

    const selectedRadioTechnologiesOptionIndex = radioTechnologies.indexOf(
      selectedRadioTechnologiesOption
    )

    const newShownRadioTechnologyFormIndices = collapseOthers
      ? []
      : [...shownRadioTechnologyFormIndices]

    if (!newShownRadioTechnologyFormIndices.includes(selectedRadioTechnologiesOptionIndex)) {
      newShownRadioTechnologyFormIndices.push(selectedRadioTechnologiesOptionIndex)
    }

    setShownRadioTechnologyFormIndices(newShownRadioTechnologyFormIndices)
  }

  const handleChangeRadioTechnology = radioTechnology => {
    expandRadioTechnologyTypesAccordion(radioTechnology, false)
    setSelectedRadioTechnologyTypes([])
    setOtherRadioTechnology('')
    setOtherRadioTechnologyType('')
    setSelectedRadioTechnology(radioTechnology)
  }

  const handleApply = () => {
    if (!onApply) return

    onApply({
      radioTechnology: selectedRadioTechnology,
      radioTechnologyTypes: selectedRadioTechnologyTypes,
      otherRadioTechnology,
      otherRadioTechnologyType,
    })
  }

  const handleSelectRadioTechnologyType = (radioTechnologyType, selectionType) => {
    if (selectionType === 'single') {
      setSelectedRadioTechnologyTypes([radioTechnologyType])
      setOtherRadioTechnologyType('')
      return
    }

    // If radio technology is already selected, unselect.
    if (selectedRadioTechnologyTypes.includes(radioTechnologyType)) {
      const newSelectedRadioTechnologyTypes = selectedRadioTechnologyTypes.filter(
        s => s !== radioTechnologyType
      )

      setSelectedRadioTechnologyTypes(newSelectedRadioTechnologyTypes)

      // If other option is unselected, clear the "Other" input.
      if (radioTechnologyType === 'Other') setOtherRadioTechnologyType('')

      return
    }

    setSelectedRadioTechnologyTypes([...selectedRadioTechnologyTypes, radioTechnologyType])
  }

  const handleChangeOtherRadioTechnology = e => {
    setOtherRadioTechnology(e.target.value)
  }

  const handleChangeOtherRadioTechnologyType = e => {
    setOtherRadioTechnologyType(e.target.value)
  }

  const dialogHeader = () => {
    return <h5 className={classes['dialog-title']}>Select Radio Technology</h5>
  }

  const isApplyDisabled = () => {
    if (!selectedRadioTechnology) return true

    const selectedRadioTechnologiesOption = radioTechnologies.find(
      r => r.radioTechnology === selectedRadioTechnology
    )

    if (selectedRadioTechnologiesOption.types?.length > 0 && !selectedRadioTechnologyTypes?.length)
      return true

    if (selectedRadioTechnology === 'Other' && !otherRadioTechnology) return true

    if (selectedRadioTechnologyTypes.includes('Other') && !otherRadioTechnologyType) return true

    return false
  }

  const dialogFooter = () => {
    return (
      <>
        <button
          disabled={isApplyDisabled()}
          onClick={handleApply}
          className={`ul-button -app-primary ${classes['btn-apply']}`}
        >
          Apply
        </button>
        <button onClick={otherProps.onHide} className="ul-button">
          CANCEL
        </button>
      </>
    )
  }

  const formHeader = rt => {
    const inputId = 'radio-technology-' + rt.radioTechnology

    return (
      <div style={{ display: 'flex' }}>
        <div style={{ marginLeft: '10px', gap: '10px' }} className="radio-button-container">
          <input
            onChange={() => {
              handleChangeRadioTechnology(rt.radioTechnology)
            }}
            defaultChecked={selectedRadioTechnology === rt.radioTechnology}
            id={inputId}
            type="radio"
            readOnly
            value={rt.radioTechnology}
            name="radio-technology"
            disabled={otherProps.isReadOnly}
          />
          <label htmlFor={inputId}>
            {rt.radioTechnology + (rt.radioTechnology === 'Other' ? ' (please specify)' : '')}
          </label>
        </div>

        {rt.radioTechnology === 'Other' && (
          <div className={classes['other-radio-technology-container']}>
            <InputText
              onChange={handleChangeOtherRadioTechnology}
              value={otherRadioTechnology}
              disabled={
                otherProps.isReadOnly ? otherProps.isReadOnly : selectedRadioTechnology !== 'Other'
              }
            />
          </div>
        )}
      </div>
    )
  }

  const formTemplate = (radioTechnology, i) => {
    if (!radioTechnology.types?.length) return

    const isRadioTechnologySelected = selectedRadioTechnology === radioTechnology.radioTechnology

    return (
      <>
        {radioTechnology.helpText && (
          <label className={classes['help-text']}>{radioTechnology.helpText}</label>
        )}

        <div className={classes['radio-type-options-container']}>
          {radioTechnology.types.map(t => {
            const inputId = radioTechnology.radioTechnology + t.type
            const label = t.type + (t.type === 'Other' ? ' (please specify)' : '')
            const onChange = () =>
              handleSelectRadioTechnologyType(t.type, radioTechnology.selectionType)

            const inputProps = {
              containerClassName: classes['checkbox-container'],
              disabled: otherProps.isReadOnly ? otherProps.isReadOnly : !isRadioTechnologySelected,
              checked: isRadioTechnologySelected && selectedRadioTechnologyTypes.includes(t.type),
              name: 'radio-technology-type',
              type: 'radio',
            }

            return (
              <div key={t.type} className={classes['radio-technology-type-field']}>
                {radioTechnology.selectionType === 'multiple' ? (
                  <Checkbox
                    inputId={inputId}
                    onChange={onChange}
                    label={label}
                    {...inputProps}
                    disabled={otherProps.isReadOnly}
                  />
                ) : (
                  <div
                    onChange={onChange}
                    className={'radio-button-container ' + classes['radio-button-container']}
                    disabled={otherProps.isReadOnly}
                  >
                    <input id={inputId} {...inputProps} readOnly />
                    <label htmlFor={inputId}>{label}</label>
                  </div>
                )}

                {t.type === 'Other' && (
                  <InputText
                    value={isRadioTechnologySelected ? otherRadioTechnologyType : ''}
                    onChange={handleChangeOtherRadioTechnologyType}
                    disabled={
                      otherProps.isReadOnly
                        ? otherProps.isReadOnly
                        : !isRadioTechnologySelected ||
                          !selectedRadioTechnologyTypes.includes('Other')
                    }
                    className={classes['other-radio-technology-type']}
                  />
                )}
              </div>
            )
          })}
        </div>
      </>
    )
  }

  return (
    <Dialog
      className={classes['radio-technology-dialog']}
      header={dialogHeader}
      footer={dialogFooter}
      draggable={false}
      resizable={false}
      visible={visible}
      {...otherProps}
    >
      <div style={{ marginTop: '30px' }}>Please select all that apply</div>

      <CollapsibleForms
        shownItemIndices={shownRadioTechnologyFormIndices}
        onSetShownItemIndices={setShownRadioTechnologyFormIndices}
        items={radioTechnologies}
        formTitleTemplate={formHeader}
        formTemplate={formTemplate}
        isReadOnly={otherProps.isReadOnly}
      />
    </Dialog>
  )
}

export default RadioTechnologyDialog
